import {createReducer} from "./index";
import {convertToDate, convertToLocalDate} from "../projections";
import * as R from 'ramda';
import {
  CLEAR_SUBVIEW,
  CLEAR_SUBVIEW_INDEX,
  CLEAR_VIEW,
  CLEAR_VIEW_INDEX,
  EXTRACT_SUBVIEW,
  EXTRACT_VIEW,
  EXTRACT_VIEW_INDEX,
  INJECT_SUBVIEW,
  INJECT_VIEW,
  SET_SUBVIEW,
  SET_SUBVIEW_CACHE,
  SET_SUBVIEW_INDEX,
  SET_VIEW,
  SET_VIEW_CACHE,
  SET_VIEW_INDEX,
  SET_VIEW_PATH
} from "../actions/view";

export const transformations = {
  datecreated: convertToDate,
  bidduedatetime: convertToDate,
  prebidmeetingdatetime: convertToDate,
  dateopened: convertToLocalDate,
  estimatedcompletiondate: convertToDate,
  duedate: convertToDate,
  replydate: convertToDate,
  replydatetime: convertToDate,
  logdate: convertToLocalDate,
  meetingdatetime: convertToDate,
  nextmeetingdatetime: convertToDate,
};

const viewInitial = {
  path: [],
  data: {},
  indexes: [],
  cache: {},
  subview: {
    data: {},
    indexes: [],
    cache: {},
  },
};

const viewReducer = createReducer(viewInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [SET_VIEW_PATH]: (state, action) => {
      let newState = state;
      newState = R.set(R.lensPath(['path']), action.payload)(newState);
      // If the view path changes, clear the data as if sending a CLEAR_VIEW action
      // TODO: This should be replaced by logic in the view selectors to only show data when the view path matches
      if (R.path(['path'], newState) !== R.path(['path'], state)) {
        if (action.payload === ['bids'] || action.payload === ['projects']) newState = R.set(R.lensPath(['data']), {})(newState);
        else newState = R.set(R.lensPath(['subview', 'data']), {})(newState);
      }
      return newState;
    },
    [SET_VIEW]: (state, action) => {
      let newState = state;
      newState = R.set(R.lensPath(['cache']), {loading: false})(state);
      newState = R.set(R.lensPath(['data']), {})(newState);
      action.payload.forEach(document => {
        if (!document.resource) {
          document = R.evolve(transformations, document);
          newState = R.set(R.lensPath(['data', document.id]), document)(newState);
        } else {
          document = R.over(R.lensPath(['resource']), R.evolve(transformations))(document);
          newState = R.set(R.lensPath(['data', document.resource.id]), document)(newState);
        }
      });
      return newState;
    },
    [INJECT_VIEW]: (state, action) => {
      let newState = state;
      action.payload.forEach(document => {
        if (!document.resource) {
          document = R.evolve(transformations, document);
          newState = R.set(R.lensPath(['data', document.id]), document)(newState);
        } else {
          document = R.over(R.lensPath(['resource']), R.evolve(transformations))(document);
          newState = R.set(R.lensPath(['data', document.resource.id]), document)(newState);
        }
      });
      return newState;
    },
    [EXTRACT_VIEW]: (state, action) => {
      let newState = state;
      action.payload.forEach(document => {
        newState = R.dissocPath(['data', document])(newState);
      });
      return newState;
    },
    [CLEAR_VIEW]: (state, action) => {
      let newState = state;
      newState = R.set(R.lensPath(['data']), {})(newState);
      return newState;
    },
    [SET_VIEW_CACHE]: (state, action) => R.set(R.lensPath(['cache']), action.payload)(state),

    // SET_SUBVIEW
    [SET_SUBVIEW]: (state, action) => {
      let newState = state;
      newState = R.set(R.lensPath(['subview', 'cache']), {loading: false})(state);
      newState = R.set(R.lensPath(['subview', 'data']), {})(newState);
      action.payload.forEach(document => {
        if (!document.resource) {
          document = R.evolve(transformations, document);
          newState = R.set(R.lensPath(['subview', 'data', document.id]), document)(newState);
        } else {
          document = R.over(R.lensPath(['resource']), R.evolve(transformations))(document);
          newState = R.set(R.lensPath(['subview', 'data', document.resource.id]), document)(newState);
        }
      });
      return newState;
    },
    [INJECT_SUBVIEW]: (state, action) => {
      let newState = state;
      action.payload.forEach(document => {
        if (!document.resource) {
          document = R.evolve(transformations, document);
          newState = R.set(R.lensPath(['subview', 'data', document.id]), document)(newState);
        } else {
          document = R.over(R.lensPath(['resource']), R.evolve(transformations))(document);
          newState = R.set(R.lensPath(['subview', 'data', document.resource.id]), document)(newState);
        }
      });
      return newState;
    },
    [EXTRACT_SUBVIEW]: (state, action) => {
      let newState = state;
      action.payload.forEach(document => {
        newState = R.dissocPath(['subview', 'data', document])(newState);
      });
      return newState;
    },
    [CLEAR_SUBVIEW]: (state, action) => R.set(R.lensPath(['subview', 'data']), {})(state),
    [SET_SUBVIEW_CACHE]: (state, action) => R.set(R.lensPath(['subview', 'cache']), action.payload)(state),

    [SET_VIEW_INDEX]: (state, action) => R.set(R.lensPath(['indexes']), action.payload)(state),
    [EXTRACT_VIEW_INDEX]: (state, action) => R.over(R.lensPath(['indexes']), R.without(action.payload))(state),
    [CLEAR_VIEW_INDEX]: (state, action) => R.set(R.lensPath(['indexes']), {})(state),

    //SET_SUBVIEW_INDEX
    [SET_SUBVIEW_INDEX]: (state, action) => R.set(R.lensPath(['subview', 'indexes']), action.payload)(state),
    [CLEAR_SUBVIEW_INDEX]: (state, action) => R.set(R.lensPath(['subview', 'indexes']), {})(state),

  });

export default viewReducer;



// WEBPACK FOOTER //
// ./src/reducers/view.js